var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSettingsNavListArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 7.41,
    height: 12,
    viewBox: "0 0 7.41 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_2650",
    "data-name": "Path 2650",
    d: "M7.41,8,12,12.58,16.59,8,18,9.41l-6,6-6-6Z",
    transform: "translate(-8 18) rotate(-90)",
    fill: "#b3b3b3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingsNavListArrow);
export default __webpack_public_path__ + "static/media/settings-nav-list-arrow.7859bfe32dc7357937cb734483a1582c.svg";
export { ForwardRef as ReactComponent };